import { useEffect } from 'react'

/**
 * Sets document.title whenever the provided value changes.
 * Pass an empty string to be a no-op (leaves the current title unchanged).
 */
export function useDocumentTitle(title: string): void {
  useEffect(() => {
    if (!title) return
    document.title = title
  }, [title])
}
